import React from "react";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import { getInternalLink } from "../../../utils/navUtils";
import { isRTL } from "../../../../common-deprecated/settings/utils/commonSettingUtils";
import * as Styles from "./styles/Vehicle";
import * as Button from "../../../../common-deprecated/styles/v2/toyota/components/Button";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { tradeInAemVehicleSetVehicle } from "../../../redux/actions/TradeInAemVehicleActions";
import type { TradeInAemVehicleType } from "../../../utils/types";
// TODO: Update this icon if available in the icon font
import IconTrash from "../../../../common-deprecated/svg/toyota/aem/trash.svg";
import { useDispatch } from "../../../../shared-logic/redux/store";

type PropsType = {
    vehicle: TradeInAemVehicleType;
    addToPreviouslySearched?: (vehicle: TradeInAemVehicleType) => void;
    removeFromPreviouslySearched?: (vehicle: TradeInAemVehicleType) => void;
};

const FindVehicleResult = (props: PropsType): JSX.Element => {
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const csl = useTradeInCsl();
    const { vehicle, addToPreviouslySearched, removeFromPreviouslySearched } = props;
    const { name, description } = csl.getVehicleName(vehicle);

    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const nextStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "next");

    return (
        <Styles.Card
            href={nextStep.href}
            onClick={(event) => {
                dispatch(tradeInAemVehicleSetVehicle(vehicle));
                if (nextStep.onClick) nextStep.onClick(event);
                if (addToPreviouslySearched) addToPreviouslySearched(vehicle);
            }}
        >
            <Styles.CardTitle>{name}</Styles.CardTitle>
            {description && <div>{description}</div>}

            <Styles.Actions>
                {removeFromPreviouslySearched && (
                    <Button.Link
                        type="button"
                        onClick={(event) => {
                            // Prevent going to the next step
                            event.preventDefault();
                            event.stopPropagation();
                            if (removeFromPreviouslySearched) removeFromPreviouslySearched(vehicle);
                        }}
                        mr={2}
                    >
                        <IconTrash />
                    </Button.Link>
                )}
                <IconWrapper>
                    <Icon variant={isRTL(commonSettings) ? "chevronLeft" : "chevronRight"} />
                </IconWrapper>
            </Styles.Actions>
        </Styles.Card>
    );
};
export default FindVehicleResult;
